import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "Money Mart";

const DEFAULT_DESCRIPTION =
  "Money Mart helps you compare and apply for Home Loans, Mortgage Loans, Business Loans, Construction Loans, Loan Against Property (LAP), Personal Loans and more from leading Banks and NBFCs.";

const SITE_NAME = process.env.REACT_APP_SITE_NAME || "Money Mart";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://money-mart.in";
// const TWITTER_HANDLE = process.env.REACT_APP_TWITTER_HANDLE;

const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  canonical = "/",
  image = DEFAULT_IMAGE,
  robots = "index, follow",
  type = "website",
  structuredData = null,
}) {
  const pageTitle =
    title === DEFAULT_TITLE ? DEFAULT_TITLE : `${title} | ${SITE_NAME}`;

  const canonicalUrl = canonical === null ? null : `${SITE_URL}${canonical}`;

  const imageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      {/* ==========================================
          Basic SEO
      ========================================== */}

      <title>{pageTitle}</title>

      <meta name="description" content={description} />

      <meta name="robots" content={robots} />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* ==========================================
          Theme
      ========================================== */}

      <meta name="color-scheme" content="light" />

      {/* ==========================================
          Open Graph
      ========================================== */}

      <meta property="og:locale" content="en_IN" />

      <meta property="og:site_name" content={SITE_NAME} />

      <meta property="og:type" content={type} />

      <meta property="og:title" content={pageTitle} />

      <meta property="og:description" content={description} />

      <meta property="og:url" content={canonicalUrl ?? SITE_URL} />

      <meta property="og:image" content={imageUrl} />

      <meta property="og:image:secure_url" content={imageUrl} />

      <meta property="og:image:type" content="image/jpeg" />

      <meta property="og:image:width" content="1200" />

      <meta property="og:image:height" content="630" />

      <meta property="og:image:alt" content={pageTitle} />

      {/* ==========================================
          Twitter Cards
      ========================================== */}

      <meta name="twitter:card" content="summary_large_image" />

      <meta name="twitter:title" content={pageTitle} />

      <meta name="twitter:description" content={description} />

      <meta name="twitter:image" content={imageUrl} />

      {/* <meta
        name="twitter:site"
        content="@MoneyMart"
      />

      <meta
        name="twitter:creator"
        content="@MoneyMart"
      /> */}

      {/* ==========================================
          Structured Data (JSON-LD)
      ========================================== */}

      {structuredData &&
        (Array.isArray(structuredData) ? structuredData : [structuredData]).map(
          (schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ),
        )}
    </Helmet>
  );
}
